<ng-container *ngIf="isDialogOpened">
    <kendo-window class="print-dialog kendo-window-with-titlebar"
                  [title]="dialogTitle"
                  [width]="550"
                  [height]="620"
                  (close)="cancel()">
      <div class="ContentContainer">
        <table class="equidistantTable fullSize" style="table-layout: fixed" aria-hidden="true">
          <tbody>
            <tr>
              <td colspan="2">
                <h1><span class="k-icon k-i-print" style="font-size: 42pt;"></span> {{'reportDesignerPrintDialog.title' | translate}}</h1>
              </td>
            </tr>
            <tr>
              <td class="distance">
                <input type="checkbox" id="addWatermark" class="k-checkbox" [(ngModel)]="settings.addWatermark">
                <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="addWatermark">{{ 'reportDesignerPrintDialog.addWatermark' | translate }}</label>
              </td>
              <td class="distance">
                <input *ngIf="settings.addWatermark" type="text" [(ngModel)]="settings.watermarkText" maxlength="20" placeholder="{{'reportDesignerPrintDialog.watermarkText' | translate}}" class="fullWidth border-1-black" />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="distance">
                <input type="checkbox" id="passwordProtect" class="k-checkbox" [(ngModel)]="settings.passwordProtect">
                <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="passwordProtect">{{ 'reportDesignerPrintDialog.passwordProtect' | translate }} *</label>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="distance">
                <input type="checkbox" id="coverPage" class="k-checkbox" [(ngModel)]="settings.hideCoverPage">
                <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="coverPage">{{ 'reportDesignerPrintDialog.coverPage' | translate }}</label>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="distance">
                <input type="checkbox" id="backCoverPage" class="k-checkbox" [(ngModel)]="settings.hideBackCoverPage">
                <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="backCoverPage">{{ 'reportDesignerPrintDialog.backCoverPage' | translate }}</label>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="distance">
                <input type="checkbox" id="hidePageNumbers" class="k-checkbox" [(ngModel)]="settings.hidePageNumbers">
                <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="hidePageNumbers">{{ 'reportDesignerPrintDialog.hidePageNumbers' | translate }}</label>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="distance">
                <input type="checkbox" id="markAsFinal" class="k-checkbox" [(ngModel)]="settings.markAsFinal">
                <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="markAsFinal">{{ 'reportDesignerPrintDialog.markAsFinal' | translate }}</label>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="distance">* {{ 'reportDesignerPrintDialog.passwordProtectHint' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
        <div class="dialogButtonBar">
          <div class="reportDesignerButtonBarBorder h-fill-available">
            <div class="ButtonBar h-fill-available">
              <button class="button-confirm ButtonWidth_110px k-button h-fill-available" (click)="publish()">{{'reportDesignerPrintDialog.publish' | translate}}</button>
              <button class="button-confirm ButtonWidth_110px k-button ml-5 h-fill-available" (click)="cancel()">{{'reportDesignerPrintDialog.cancel' | translate}}</button>
            </div>
          </div>
      </div>
    </kendo-window>
  <div class="k-overlay"></div>
</ng-container>
